var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "nav",
      { staticClass: "navbar navbar-default no-margin app-sidebar-nav" },
      [
        _c("div", { staticClass: "navbar-header fixed-brand" }, [
          _c(
            "button",
            {
              staticClass: "navbar-toggle collapsed",
              attrs: {
                type: "button",
                "data-toggle": "collapse",
                id: "menu-toggle"
              }
            },
            [
              _c("span", {
                staticClass: "glyphicon glyphicon-th-large",
                attrs: { "aria-hidden": "true" }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "navbar-brand",
              attrs: { href: "javascript:void(0)" }
            },
            [
              _c("img", {
                attrs: {
                  src: "/static/images/logo.png",
                  alt: "Velocity Vehicle Group"
                }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "collapse navbar-collapse",
            attrs: { id: "bs-example-navbar-collapse-1" }
          },
          [
            _c("ul", { staticClass: "nav navbar-nav" }, [
              _c("li", { staticClass: "active" }, [
                _c(
                  "button",
                  {
                    staticClass: "navbar-toggle collapse in",
                    attrs: { "data-toggle": "collapse", id: "menu-toggle-2" }
                  },
                  [
                    _c("img", {
                      staticClass: "menubar",
                      attrs: { src: "/static/images/menubar.png", alt: "Menu" }
                    })
                  ]
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "notification" }, [
          _c("a", { attrs: { href: "#" } }, [
            _c("img", {
              attrs: {
                src: "/static/images/notification-bell.png",
                alt: "Notification"
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "user-info" }, [
          _c("div", { staticClass: "user-info-container" }, [
            _c("div", { staticClass: "dropdown" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary dropdown-toggle",
                  attrs: { type: "button", "data-toggle": "dropdown" }
                },
                [
                  _c("div", { staticClass: "dropdown-user" }, [
                    _c("div", { staticClass: "username-letter" }, [
                      _vm._v("AG")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "dropdown-user-right" }, [
                      _c("div", { staticClass: "username" }, [
                        _vm._v("ALBERT GAMBOA")
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("div", { staticClass: "usermailid" }, [
                        _vm._v("agamboa@vvgtruck.com")
                      ])
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown-menu" }, [
                _c(
                  "a",
                  { staticClass: "dropdown-item", attrs: { href: "#" } },
                  [_vm._v("My Profile")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  { staticClass: "dropdown-item", attrs: { href: "#" } },
                  [_vm._v("Inbox")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  { staticClass: "dropdown-item", attrs: { href: "#" } },
                  [_vm._v("Account Setting")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  { staticClass: "dropdown-item", attrs: { href: "#" } },
                  [_vm._v("Logout")]
                )
              ])
            ])
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9a456d62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a456d62","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/partials/header.vue
// module id = null
// module chunks = 